import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OrderStateType, ApiGetDataStatus } from '@redux/types'
import {
	Order,
	OrderType,
	OrderCreationType,
	OrderUpdateType,
	OrderDeletionType,
} from '@schemas'
import dayjs from 'dayjs'

const today = dayjs().format('YYYY-MM-DD')

const initialState: OrderStateType = {
	// trigger
	triggerInitOrderPage: false,
	triggerOrderSearch: false,
	triggerOrderPreparing: false,
	triggerOrderLabelPrinting: false,
	triggerUpdateOrderTransit: false,
	triggerDeleteOrder: false,
	triggerRefundOrder: false,

	// search order
	searchStartDate: dayjs(today).format('YYYY-MM-01'),
	searchEndDate: dayjs(today).endOf('month').format('YYYY-MM-DD'),
	searchStatus: 'new',
	searchKeyword: '',

	// view
	viewTabIndex: 0,

	// order list
	orderStatus: 'init',
	orderList: [],
	selectedOrder: new Order(),

	loading: false,
	error: '',
	selectedYear: dayjs().format('YYYY-MM'),
	isDeletedIncluding: '1',

	// selection
	selectedOrderIds: [],
	selectedStatusArr: [],
}

const orderSlice = createSlice({
	name: 'order',
	initialState,
	reducers: {
		// trigger
		TRIGGER_INIT_ORDER_PAGE: (state: OrderStateType, action: PayloadAction<boolean>) => {
			state.loading = true
			state.triggerInitOrderPage = action.payload
		},
		TRIGGER_ORDER_SEARCH: (state: OrderStateType, action: PayloadAction<boolean>) => {
			state.triggerOrderSearch = action.payload
		},
		TRIGGER_ORDER_PREPARING: (state: OrderStateType, action: PayloadAction<boolean>) => {
			state.triggerOrderPreparing = action.payload
		},
		TRIGGER_ORDER_LABEL_PRINTING: (
			state: OrderStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerOrderLabelPrinting = action.payload
		},
		TRIGGER_UPDATE_ORDER_TRANSIT: (
			state: OrderStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerUpdateOrderTransit = action.payload
		},
		TRIGGER_DELETE_ORDER: (state: OrderStateType, action: PayloadAction<boolean>) => {
			state.triggerDeleteOrder = action.payload
		},
		TRIGGER_REFUND_ORDER: (state: OrderStateType, action: PayloadAction<boolean>) => {
			state.triggerRefundOrder = action.payload
		},

		// search order
		SEARCH_START_DATE: (state: OrderStateType, action: PayloadAction<string>) => {
			state.searchStartDate = action.payload
		},
		SEARCH_END_DATE: (state: OrderStateType, action: PayloadAction<string>) => {
			state.searchEndDate = action.payload
		},
		SEARCH_STATUS: (state: OrderStateType, action: PayloadAction<string>) => {
			state.searchStatus = action.payload
		},
		SEARCH_KEYWORD: (state: OrderStateType, action: PayloadAction<string>) => {
			state.searchKeyword = action.payload
		},

		// view
		VIEW_TAB_INDEX: (state: OrderStateType, action: PayloadAction<number>) => {
			state.viewTabIndex = action.payload
		},

		// order list
		ORDER_STATUS: (state, action: PayloadAction<ApiGetDataStatus>) => {
			state.orderStatus = action.payload
		},
		ORDER_LIST: (state, action: PayloadAction<OrderType[]>) => {
			state.orderList = action.payload
		},
		SELECTED_ORDER: (state, action: PayloadAction<OrderType>) => {
			state.selectedOrder = action.payload
		},
		// 주문 조회 설정 관련 (년도, 삭제 여부)
		IS_DELETED_INCLUDING: (state, action: PayloadAction<'0' | '1'>) => {
			state.isDeletedIncluding = action.payload
		},
		SET_SELECTED_YEAR: (state, action: PayloadAction<string>) => {
			state.selectedYear = action.payload
		},
		// 주문 등록 관련
		REGISTER_ORDER: (state, action: PayloadAction<OrderCreationType>) => {
			state.loading = true
		},
		REGISTER_ORDER_SUCCESS: state => {
			state.loading = false
		},
		REGISTER_ORDER_FAILURE: (state, action: PayloadAction<string>) => {
			state.error = action.payload
			state.loading = false
		},
		// 주문 수정 관련
		UPDATE_ORDER: (
			state,
			action: PayloadAction<{
				orderId: string
				order: OrderUpdateType
			}>,
		) => {
			state.loading = true
		},
		UPDATE_ORDER_SUCCESS: state => {
			state.loading = false
		},
		UPDATE_ORDER_FAILURE: (state, action: PayloadAction<string>) => {
			state.error = action.payload
			state.loading = false
		},
		// 주문 삭제 관련
		DELETE_ORDER: (state, action: PayloadAction<OrderDeletionType>) => {
			state.loading = true
		},
		DELETE_ORDER_SUCCESS: state => {
			state.loading = false
		},
		DELETE_ORDER_FAILURE: (state, action: PayloadAction<string>) => {
			state.error = action.payload
			state.loading = false
		},

		// select
		SELECTED_ORDER_IDS: (state: OrderStateType, action: PayloadAction<string[]>) => {
			state.selectedOrderIds = action.payload
		},
		SELECTED_STATUS_ARR: (state: OrderStateType, action: PayloadAction<string[]>) => {
			state.selectedStatusArr = action.payload
		},
	},
})

export const orderActions = orderSlice.actions
export default orderSlice.reducer
